/**
 * Created by i.lovenkov on 30.11.16.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require("redbox-react");

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require("react");

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require("react-transform-catch-errors");

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    RegistrationHeaderView: {
        displayName: "RegistrationHeaderView"
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: "/usr/local/ibonus/src/components/Registration/RegistrationHeader/default/RegistrationHeaderView.jsx",
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var RegistrationHeaderView = _wrapComponent("RegistrationHeaderView")((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(RegistrationHeaderView, _Component);

    function RegistrationHeaderView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, RegistrationHeaderView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationHeaderView.__proto__ || (0, _getPrototypeOf2.default)(RegistrationHeaderView)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
            event.preventDefault();
            _this.props.onClick(event);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(RegistrationHeaderView, [{
        key: "render",
        value: function render() {
            // Чтобы юзер не успел перейти на страницу регистрации
            // до того, как подгрузятся скрипты. Если скрипты не успевают подхватит и
            // юзер кликает на ссылку, то вместо модалки переходит на саму страницу.
            // Было рещено, что так не надо делать.
            if (__SERVER__) {
                return _react3.default.createElement(
                    "a",
                    { href: "#" },
                    _react3.default.createElement(
                        "span",
                        { className: "auth_span" },
                        this.props.lang['store.register.register']
                    )
                );
            }

            return _react3.default.createElement(
                _reactRouter.Link,
                { to: "/registration", onClick: this.onClick },
                _react3.default.createElement(
                    "span",
                    { className: "auth_span" },
                    this.props.lang['store.register.register']
                )
            );
        }
    }]);
    return RegistrationHeaderView;
}(_react2.Component), _class.propTypes = {
    onClick: _react2.PropTypes.func,
    lang: _react2.PropTypes.object
}, _temp2));

exports.default = RegistrationHeaderView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/RegistrationHeader/default/RegistrationHeaderView.jsx
// module id = 1753
// module chunks = 0